import React from 'react'
import {
  Button,
  Center,
  Heading,
  HStack,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Text,
  useDisclosure,
  VStack,
} from '@chakra-ui/react'
import { colors } from '../../../utils/theme/styles'

export default function PaymentData() {
  const { isOpen, onOpen, onClose } = useDisclosure()
  return (
    <>
      <Text
        _hover={{
          cursor: 'pointer',
        }}
        color="#0086D6"
        variant="caption1"
        onClick={onOpen}
      >
        Datos para pago
      </Text>

      <Modal size="5xl" isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalBody p={0}>
            <HStack alignItems="flex-start" w="100%">
              <VStack
                p="15px"
                justifyContent="flex-start"
                alignItems="center"
                border="1px solid #74BF00"
                bgColor="#F7F7F7"
                w="100%"
              >
                <Heading variant="h5" color={colors.gray[900]}>
                  BANCO DE CHILE
                </Heading>
                <Text variant="body1" color="565656">
                  CUENTA CORRIENTE
                </Text>
                <Text variant="body1" color="565656">
                  FDD INNOVACION Y CRECIMIENTO S.A
                </Text>
                <Text variant="body1" color="565656">
                  RUT: 76.032.107-9
                </Text>
                <Text variant="body1" color="565656">
                  BANCO DE CHILE
                </Text>
                <Text variant="body1" color="565656">
                  N° CUENTA: 08000711007
                </Text>
                <Text variant="body1" color="565656">
                  Contacto: Cinthya Calderón
                </Text>
                <Text variant="body1" color="565656">
                  Empresas Privadas: C.calderon@amipass.com
                </Text>
                <Text variant="body1" color="565656">
                  Instituciones Públicas: m.valenzuelas@amipass.com
                </Text>
              </VStack>
              <VStack
                p="15px"
                justifyContent="flex-start"
                alignItems="center"
                border="1px solid #74BF00"
                bgColor="#F7F7F7"
                w="100%"
              >
                <Heading variant="h5" color={colors.gray[900]}>
                  BANCO CRÉDITO E INVERSIONES (BCI)
                </Heading>
                <Text variant="body1" color="565656">
                  CUENTA CORRIENTE
                </Text>
                <Text variant="body1" color="565656">
                  FDD INNOVACION Y CRECIMIENTO S.A
                </Text>
                <Text variant="body1" color="565656">
                  RUT: 76.032.107-9
                </Text>
                <Text variant="body1" color="565656">
                  BANCO CREDITO E INVERSIONES
                </Text>
                <Text variant="body1" color="565656">
                  N° CUENTA: 86249584
                </Text>
                <Text variant="body1" color="565656">
                  Contacto: Cinthya Calderón
                </Text>
                <Text variant="body1" color="565656">
                  Empresas Privadas: C.calderon@amipass.com
                </Text>
                <Text variant="body1" color="565656">
                  Instituciones Públicas: m.valenzuelas@amipass.com
                </Text>
              </VStack>
            </HStack>
          </ModalBody>

          <ModalFooter>
            <Center w="100%" h="100%">
              <Button
                borderRadius="14px"
                w="257px"
                h="56px"
                variant="primary"
                mr={3}
                onClick={onClose}
              >
                Cerrar ventana{' '}
              </Button>
            </Center>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
